import script from "./PostGridView.vue?vue&type=script&setup=true&lang=js"
export * from "./PostGridView.vue?vue&type=script&setup=true&lang=js"

import "./PostGridView.vue?vue&type=style&index=0&id=0b4320e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b4320e6"]])

export default __exports__